import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { testimonials } from '../../../data/testimonials';
import './testimonial.css';

export const Testimonial = () => {
  const [active, setActive] = useState(0);
  const total = testimonials.length;

  const prev = () => setActive((i) => (i - 1 + total) % total);
  const next = () => setActive((i) => (i + 1) % total);

  const leftIdx = (active - 1 + total) % total;
  const rightIdx = (active + 1) % total;

  return (
    <section className="testimonial">
      <Container fluid className="testimonial__container">

        {/* Header */}
        <h2 className="testimonial__title">Patients Testimonials</h2>
        <p className="testimonial__subtitle">
          Learn from leading doctors and specialists through focused, digestible video content.
        </p>

        {/* Cards */}
        <div className="testimonial__stage">

          {/* Left card */}
          <div className="testimonial__card testimonial__card--side">
            <div className="testimonial__avatar-wrap">
              <img src={testimonials[leftIdx].avatar} alt={testimonials[leftIdx].name} className="testimonial__avatar" />
            </div>
            <div className="testimonial__card-body">
              <p className="testimonial__quote">{testimonials[leftIdx].quote}</p>
              <p className="testimonial__name">{testimonials[leftIdx].name}</p>
              <p className="testimonial__role">{testimonials[leftIdx].role}</p>
            </div>
          </div>

          {/* Center card (active) */}
          <div className="testimonial__card testimonial__card--center">
            <div className="testimonial__avatar-wrap testimonial__avatar-wrap--center">
              <img src={testimonials[active].avatar} alt={testimonials[active].name} className="testimonial__avatar testimonial__avatar--center" />
            </div>
            <div className="testimonial__card-body testimonial__card-body--center">
              <p className="testimonial__quote testimonial__quote--center">{testimonials[active].quote}</p>
              <p className="testimonial__name testimonial__name--center">{testimonials[active].name}</p>
              <p className="testimonial__role">{testimonials[active].role}</p>
            </div>
          </div>

          {/* Right card */}
          <div className="testimonial__card testimonial__card--side">
            <div className="testimonial__avatar-wrap">
              <img src={testimonials[rightIdx].avatar} alt={testimonials[rightIdx].name} className="testimonial__avatar" />
            </div>
            <div className="testimonial__card-body">
              <p className="testimonial__quote">{testimonials[rightIdx].quote}</p>
              <p className="testimonial__name">{testimonials[rightIdx].name}</p>
              <p className="testimonial__role">{testimonials[rightIdx].role}</p>
            </div>
          </div>

        </div>

        {/* Navigation */}
        <div className="testimonial__nav">
          <button className="testimonial__nav-btn" onClick={prev} aria-label="Previous">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button className="testimonial__nav-btn testimonial__nav-btn--active" onClick={next} aria-label="Next">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>

      </Container>
    </section>
  );
};
